import { render } from "./buttonLight.vue?vue&type=template&id=2d8fa0d1"
import script from "./buttonLight.vue?vue&type=script&lang=js"
export * from "./buttonLight.vue?vue&type=script&lang=js"

import "./buttonLight.vue?vue&type=style&index=0&id=2d8fa0d1&lang=css"

import exportComponent from "/Users/matjeez/Matjez/Projects/websites/simonkr-feb24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__